export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || '48eeeee1-11b3-4920-ac90-ea00bd11beb2';
export const TENANT_ID = process.env.REACT_APP_TENANT_ID || 'a6b367ba-ec52-46fe-86eb-4eb23357a8ab';
export const TOKEN_SCOPE = process.env.REACT_APP_TOKEN_SCOPE || 'api://business-trips-apis/.default';
